export class Feature {
  identifier: string;
  name: string;
}
